import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IUser } from "../../utils/types/models";

export default createEntityReducer<IUser>(Endpoint.Technicians);
